import { useState, useMemo } from 'react'
import fuzzysort from 'fuzzysort'

interface IUseSearchProps<T> {
  dataSet: T[]
  keys: string[]
}

export default function useSearch<T>({ dataSet, keys }: IUseSearchProps<T>) {
  const [searchValue, setSearchValue] = useState('')

  const results = useMemo(() => {
    if (!searchValue) return dataSet

    const options = {
      limit: 20, // don't return more results than you need!
      threshold: -10000, // don't return bad results,
      keys,
    }

    const searchResults = fuzzysort.go(searchValue, dataSet, options)

    return searchResults.map((result) => result.obj)
  }, [searchValue, dataSet, keys])

  return {
    searchValue,
    setSearchValue,
    results,
  }
}
